import React from "react";
import { Store, Code2, Bot, PhoneCall } from "lucide-react";

const STEPS = [
  { icon: Store, title: "List your business", body: "Create your SAM profile with services, hours, photos, deals and real reviews — the signals AI trusts." },
  { icon: Code2, title: "We structure it for AI", body: "Your listing is published with clean, machine-readable data (schema.org) that AI engines and Google read and rank." },
  { icon: Bot, title: "AI recommends you", body: "When neighbors ask ChatGPT, Gemini, Perplexity or Google's AI for the best local pro, your business surfaces by name." },
  { icon: PhoneCall, title: "You get the lead", body: "Calls, bookings and messages flow straight into your Saving America Money marketing dashboard." },
];

export default function AiSearchExplainer() {
  return (
    <section className="mx-auto max-w-7xl px-4 sm:px-6 py-16" data-testid="ai-search-explainer">
      <div className="rounded-3xl bg-gradient-to-br from-sam-navy to-sam-navy2 text-sam-cream p-8 sm:p-12 relative overflow-hidden">
        <div className="absolute -left-20 -bottom-20 h-64 w-64 rounded-full bg-sam-amber/10 blur-3xl" />
        <div className="relative">
          <span className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-sam-amber">
            <Bot className="h-4 w-4" />GEO &amp; AI Search
          </span>
          <h2 className="mt-3 font-display text-3xl sm:text-4xl font-black max-w-2xl leading-tight">How AI finds you on Saving America Money</h2>
          <p className="mt-4 text-sam-cream/75 max-w-2xl text-base">
            More neighbors now ask AI to find local businesses and home services near them. Getting listed puts your business in the data these AI engines pull from — so you show up when it matters most.
          </p>
          <div className="mt-9 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {STEPS.map((s, i) => (
              <div key={s.title} className="relative rounded-2xl bg-white/5 ring-1 ring-white/10 p-5" data-testid={`ai-step-${i + 1}`}>
                <div className="flex items-center justify-between">
                  <span className="grid place-items-center h-10 w-10 rounded-xl bg-sam-amber text-sam-navy"><s.icon className="h-5 w-5" /></span>
                  <span className="font-display font-black text-white/15 text-3xl leading-none">{i + 1}</span>
                </div>
                <div className="mt-4 font-display font-bold text-sam-cream">{s.title}</div>
                <p className="text-sm text-sam-cream/70 mt-1 leading-relaxed">{s.body}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
